var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramArtTabM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 76,
    viewBox: "0 0 43 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5.58776L27.4592 17.504H15.5408L21.5 5.58776ZM21.5 0L11.5 20H31.5L21.5 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.0264L18.6414 15.7269H24.3533L21.5 10.0264Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.709 29.1494H16.7512V46.8468H19.709V29.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.77 29.1494H24.8123V46.8468H27.77V29.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1074 36.0114L17.754 38.8818L18.7092 41.701L27.0626 38.8305L26.1074 36.0114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3897 29.1729H3V32.1516H13.3897V29.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67601 30.6621H6.71826V46.8276H9.67601V30.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6244 48L29.8169 37.3901L36.3239 28L38.7465 29.7021L33.4554 37.3381L40 46.2269L37.6244 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8123 35.877H31.6385V38.8557H38.8123V35.877Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2219 75.1066L7.47114 62.0952L2.97853 75.0823L0 74.0971L5.9372 56.9168L7.25271 56.9071L8.91076 56.8926L15.1855 74.0729L12.2219 75.1066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78053 69.7859L7.59717 67.6514L5.41381 69.7859L7.59717 71.9204L9.78053 69.7859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0632 75.3108H17.9159V56L29.8399 62.4547L21.098 71.4477L21.0632 71.4137V75.3108ZM21.0632 61.2172V67.0167L24.7566 63.2167L21.0632 61.2172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6245 66.7766L21.2897 68.8398L27.9073 75.9974L30.2422 73.9342L23.6245 66.7766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 56.835H31.9397V59.9119H43V56.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 58.373H35.8961V75.0729H39.0434V58.373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "white",
    transform: "translate(3 28)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 20,
    fill: "white",
    transform: "translate(0 56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramArtTabM);
export default __webpack_public_path__ + "static/media/programArtTabM.42df25fc3514307287eec30a860d2a1a.svg";
export { ForwardRef as ReactComponent };